__turbopack_context__.v({
  "blocksBackgroundColor": "Leaderboard-module-scss-module__n3CA9G__blocksBackgroundColor",
  "blocksFontColor": "Leaderboard-module-scss-module__n3CA9G__blocksFontColor",
  "container": "Leaderboard-module-scss-module__n3CA9G__container",
  "eventsWidget": "Leaderboard-module-scss-module__n3CA9G__eventsWidget",
  "header": "Leaderboard-module-scss-module__n3CA9G__header",
  "item": "Leaderboard-module-scss-module__n3CA9G__item",
  "itemButton": "Leaderboard-module-scss-module__n3CA9G__itemButton",
  "itemContent": "Leaderboard-module-scss-module__n3CA9G__itemContent",
  "itemIsMe": "Leaderboard-module-scss-module__n3CA9G__itemIsMe",
  "score": "Leaderboard-module-scss-module__n3CA9G__score",
  "secondaryNavBackgroundColor": "Leaderboard-module-scss-module__n3CA9G__secondaryNavBackgroundColor",
  "themeBackgroundColor": "Leaderboard-module-scss-module__n3CA9G__themeBackgroundColor",
  "themeFontColor": "Leaderboard-module-scss-module__n3CA9G__themeFontColor",
  "themeFontFamily": "Leaderboard-module-scss-module__n3CA9G__themeFontFamily",
  "upcomingNews": "Leaderboard-module-scss-module__n3CA9G__upcomingNews",
  "widget": "Leaderboard-module-scss-module__n3CA9G__widget",
});
